<ejs-dialog
  *ngIf="hasErrors$ | async"
  [visible]="true"
  [isModal]="true"
  [closeOnEscape]="false"
  [showCloseIcon]="true"
  [header]="'TPA.ErrorOccurred' | transloco"
  (close)="dismissAll()"
  width="500px"
>
  <ng-template #content>
    <div
      *ngFor="let error of errors$ | async; trackBy: trackById"
      class="announcement announcement--danger error-dialog__item"
    >
      <div class="error-dialog__text">
        <strong *ngIf="error.title" class="error-dialog__title">{{
          error.title
        }}</strong>
        <span *ngIf="error.content">{{ error.content }}</span>
      </div>
      <button
        type="button"
        class="error-dialog__dismiss"
        [attr.aria-label]="'TPA.Close' | transloco"
        (click)="dismiss(error.id)"
      >
        <i class="fal fa-times"></i>
      </button>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="e-btn e-lib e-outline e-primary" (click)="dismissAll()">
      {{ 'TPA.Close' | transloco }}
    </button>
  </ng-template>
</ejs-dialog>
